import { WaveFormAudio } from "./WaveFormAudio";
export default WaveFormAudio;
//# sourceMappingURL=index.js.map